// src/components/Arguente/ArguenteDetails.jsx
import React, { useEffect, useState } from 'react';
import { obterArguente } from '../../services/arguenteService';
import { useParams } from 'react-router-dom';

const ArguenteDetails = () => {
    const { id } = useParams();
    const [arguente, setArguente] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            const response = await obterArguente(id);
            setArguente(response.data);
        };
        fetchData();
    }, [id]);

    if (!arguente) return <p>Carregando...</p>;

    return (
        <div>
            <h2>Nome: {arguente.usuario.nome}</h2>
            <p>Email: {arguente.usuario.email}</p>
            <p>Áreas de Interesse: {arguente.areasInteresse.join(', ')}</p>
            <p>Quantidade de Defesas Avaliadas: {arguente.quantidadeDefesasAvaliadas}</p>
        </div>
    );
};

export default ArguenteDetails;